export function Protpage() {
  return (
    <>
      <h1 style={{ textAlign: "center" }}>This is a Protpage</h1>
    </>
  );
}
